import React, { useState, useEffect } from "react";
import withApi from "../../higherOrderComponents/withApi";
import ReactSelect from "react-select";

export const AvailabilityInfo = withApi(({ api, productId }) => {
  const [loadedData, setData] = useState(null);
  const [editing, setEdit] = useState(null);
  const [editedAvailability, setEditAvailability] = useState(null);
  const [editedAvailableFrom, setAvailableFrom] = useState(null);
  const [editedAvailableTo, setAvailableTo] = useState(null);
  const [isDisabled, setIsDisabled] = useState(null);
  const [editedFrom, setFrom] = useState(null);
  const [editedTo, setTo] = useState(null);
  const [editedDay, setDay] = useState(null);
  const [integrationId, setIntegrationId] = useState(null);

  useEffect(() => {
    async function loadFromApi() {
      const integration = await api.integrations.getIntegrationByProductId(
        productId
      );
      setIntegrationId(integration.Id);
      const loadedAvailabilityInfo = await api.integrations.getAvailabilityInfo(
        integration.Id
      );
      setIsDisabled(loadedAvailabilityInfo.disabled);
      setData(loadedAvailabilityInfo);
    }

    if (!loadedData) {
      loadFromApi();
    }
  }, []);

  const daysMapped = [
    {value: 1, label: "Monday"},
    {value: 2, label: "Tuesday"},
    {value: 4, label: "Wednesday"},
    {value: 8, label: "Thursday"},
    {value: 16, label: "Friday"},
    {value: 32, label: "Saturday"},
    {value: 64, label: "Sunday"}
  ];

  const removeSchedule = async (scheduleId) => {
    const indexToRemove = loadedData.schedules.findIndex(
      (schedule) => schedule.id === scheduleId
    );
    loadedData.schedules.splice(indexToRemove, 1);
    const updatedAvailability = { ...loadedData };
    console.log(updatedAvailability);
    await api.integrations.editAvailabilityInfo(updatedAvailability);
    setData(await api.integrations.getAvailabilityInfo(integrationId));
  };

  if (loadedData === null) {
    return <React.Fragment>Loading...</React.Fragment>;
  }

  return (
    <React.Fragment>
      <h3>Availability Info</h3>
      <table className="data-lists component-data-table cell-content-align-top data-table-no-results">
        <thead>
          <tr style={{ backgroundColor: "#5e5e5e", color: "#f1f1f3" }}>
            <td>AvailableFrom</td>
            <td>AvailableTo</td>
            <td>Disabled</td>
            <td></td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          {editedAvailability == loadedData.integrationId ? (
            <tr>
              <td>
                <input
                  type="text"
                  value={editedAvailableFrom}
                  onChange={(e) => {
                    console.log(e.target.value);
                    setAvailableFrom(e.target.value);
                  }}
                ></input>
              </td>
              <td>
                <input
                  type="text"
                  value={editedAvailableTo}
                  onChange={(e) => {
                    console.log(e.target.value);
                    setAvailableTo(e.target.value);
                  }}
                ></input>
              </td>
              <td>
                <input
                  type="checkbox"
                  checked={isDisabled}
                  onChange={(e) => {
                    setIsDisabled(e.target.checked);
                  }}
                />
              </td>
              <td
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setEditAvailability(null);
                }}
              >
                Cancel
              </td>
              <td
                style={{ cursor: "pointer" }}
                onClick={async () => {
                  const updatedAvailability = {
                    ...loadedData,
                    availableFrom: editedAvailableFrom,
                    availableTo: editedAvailableTo,
                    disabled: isDisabled,
                  };
                  await api.integrations.editAvailabilityInfo(
                    updatedAvailability
                  );
                  setData(
                    await api.integrations.getAvailabilityInfo(integrationId)
                  );
                  setEditAvailability(false);
                }}
              >
                Save
              </td>
            </tr>
          ) : (
            <tr>
              <td style={{ color: isDisabled ? "grey" : "auto" }}>
                {loadedData.availableFrom}
              </td>
              <td style={{ color: isDisabled ? "grey" : "auto" }}>
                {loadedData.availableTo}
              </td>
              <td>
                <input type="checkbox" checked={loadedData.disabled} disabled />
              </td>
              <td
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setEditAvailability(integrationId);
                  setAvailableFrom(loadedData.availableFrom);
                  setAvailableTo(loadedData.availableTo);
                }}
              >
                Edit
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <br />
      <br />
      <button
        type="button"
        className="button button-color-primary button-shrink-limited"
        onClick={async () => {
          loadedData.schedules = loadedData.schedules || [];
          loadedData.schedules.push({
            integrationId: integrationId,
            day: 1,
            from: "01:00:00",
            to: "23:59:00",
          });
          await api.integrations.editAvailabilityInfo(loadedData);
          const newlyLoadedData = await api.integrations.getAvailabilityInfo(
            integrationId
          );
          setData(newlyLoadedData);
        }}
      >
        New Schedule
      </button>
      <br></br>
      <br></br>
      <table className="data-lists component-data-table cell-content-align-top data-table-no-results">
        <thead>
          <tr style={{ backgroundColor: "#5e5e5e", color: "#f1f1f3" }}>
            <td>From</td>
            <td>To</td>
            <td>DayOfWeek</td>
            <td></td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          {!loadedData.schedules
            ? ""
            : loadedData.schedules.map((whole) => {
                const { id, from, to, day } = whole;

                if (editing == id) {
                  return (
                    <tr key={id}>
                      <td style={{width: '20%'}}>
                        <input
                          type="text"
                          value={editedFrom}
                          onChange={(e) => {
                            console.log(e.target.value);
                            setFrom(e.target.value);
                          }}
                        ></input>
                      </td>
                      <td style={{width: '20%'}}>
                        <input                     
                          type="text"
                          value={editedTo}
                          onChange={(e) => {
                            console.log(e.target.value);
                            setTo(e.target.value);
                          }}
                        ></input>
                      </td>
                      <td style={{width: '20%'}}>
                        <ReactSelect
                          className="react-select-filters-section"
                          classNamePrefix="react-select-filters-section-prefix"
                          value={
                            daysMapped.filter(
                              (x) => x.value === editedDay
                            ) || ""
                          }
                          onChange={(selection) =>
                            setDay(console.log(selection.value) || selection.value)
                          }
                          options={daysMapped}
                        ></ReactSelect>
                      </td>
                      <td
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setEdit(null);
                        }}
                      >
                        Cancel
                      </td>
                      <td
                        style={{ cursor: "pointer" }}
                        onClick={async () => {
                          const index = loadedData.schedules
                            .map((x) => x.id)
                            .indexOf(editing);
                          loadedData.schedules[index].from = editedFrom;
                          loadedData.schedules[index].to = editedTo;
                          loadedData.schedules[index].day = daysMapped.filter(x => x.value === editedDay)[0].value;

                          const updatedAvailability = { ...loadedData };
                          await api.integrations.editAvailabilityInfo(
                            updatedAvailability
                          );
                          setData(
                            await api.integrations.getAvailabilityInfo(
                              integrationId
                            )
                          );
                          setEdit(null);
                        }}
                      >
                        Save
                      </td>
                    </tr>
                  );
                }

                return (
                  <tr key={id}>
                    <td>{from}</td>
                    <td>{to}</td>
                    <td>{daysMapped.filter(x => x.value === day)[0].label}</td>
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={async () => {
                        const result = confirm(
                          "Are you sure to delete this entry ?"
                        );
                        if (!result) {
                          return;
                        }

                        await removeSchedule(id);
                      }}
                    >
                      Delete
                    </td>
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setEdit(id);
                        setFrom(from);
                        setTo(to);
                        setDay(parseInt(day));
                      }}
                    >
                      Edit
                    </td>
                  </tr>
                );
              })}
        </tbody>
      </table>
    </React.Fragment>
  );
});
